import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ui-menu-group",
  "use": "ui-menu-group-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"ui-menu-group\"><g id=\"ui-menu-group_asus_proart_sw_ico_taskgroup\"><rect width=\"48\" height=\"48\" fill=\"none\" /><path d=\"M35,40H13a5,5,0,0,1-5-5V13a5,5,0,0,1,5-5H35a5,5,0,0,1,5,5V35A5,5,0,0,1,35,40ZM13,10a3,3,0,0,0-3,3V35a3,3,0,0,0,3,3H35a3,3,0,0,0,3-3V13a3,3,0,0,0-3-3Zm1.5,4.5h8v8h-8Zm11,0v8h8v-8Zm-11,19h8v-8h-8Zm11,0h8v-8h-8Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol